import { Editor } from "shared/hubrise/editor"
import { objectHash } from "shared/utils/hash"

export const computeEditorsHash = (editors: { [catalogId: string]: Editor }): string => {
  // Keep this method fast, it is called on every catalog update.
  const catalogHashes = Object.values(editors).map((editor) => editor.hash)
  return objectHash(catalogHashes)
}
